import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import { IPricingProfileAccessItem } from 'pricing/types';

export const getPricingProfileAccessItems = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
) => {
  const { data } = await partfinitiClient.get(
    `/pricing/access-item-list/items?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IPricingProfileAccessItem>(data.data, data.recordsFiltered);
};

export const upsertPricingProfileAccess = async (data: Record<string, unknown>) => {
  return partfinitiClient.postForm('/pricing/access-item-edit/save', data);
};

export const removePricingProfileAccess = async (data: { ids: number[] }) => {
  return partfinitiClient.postForm('/pricing/access-item-edit/remove', data);
};
